<template>
  <div>
    <div
      v-if="locomo7 && locomo7.length > 0"
      class="row"
      style="border: 1px solid #e0e0e0"
    >
      <div class="d-flex col-12 justify-content-between ps-3 pe-3 py-2" style="background-color: #f8f8fb;">
        <div><h5 class="text-list-locomo-7 mb-1">履歴照会</h5></div>
      </div>
      <div class="p-0">
        <Spliter :initialLeftWidth="250">
          <template #left>
            <div class="col-12 px-1"> 
              <div class="mt-2 px-1">
                <b-button class="w-lg btn-edit" :disabled="listIds.length === 0" :class="{'bg-disabled': listIds.length === 0}" @click="exportExcel()">Excel出力</b-button>
              </div>
              <div class="table-responsive mt-2 mb-0 scroll" :style="{maxHeight: isExpand ? '65vh': '50vh'}">
                <vue-loadmore
                  :on-refresh="onRefresh"
                  :on-loadmore="onLoad"
                  loading-text="読み込み中"
                  :finished="finished"
                  finished-text=" "
                >
                  <table class="table align-middle mb-0">
                    <tbody>
                      <tr
                        v-for="(history, index) in locomo7"
                        :key="index"
                        @click="getImages(index), (clickIndex = index)"
                        style="cursor: pointer"
                      >
                        <td
                          class="text-center pe-1"
                          :class="{ 'bg-active-locomo': index === clickIndex }"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            @click="checkedLocomo(history.uuid)"
                            id="formCheckRight2"
                            :checked="isChecked(history.uuid)"
                            style="font-size: 24px; margin: 0;"
                          />
                        </td>
                        <td
                          width="50%"
                          :class="{ 'bg-active-locomo': index === clickIndex }"
                          class="text-start px-1"
                        >
                          <h5 class="text-list-locomo-7 mb-0">
                            {{ history.created_at | fomatDate2 }}
                          </h5>
                        </td>
                        <td style="min-width: 80px;"
                          width="50%"
                          class="text-start px-2"
                          :class="{ 'bg-active-locomo': index === clickIndex }"
                        >
                          <h5 class="mb-0 text-list-locomo-7 text-right">
                            {{ history.current_score }} / {{ history.max_score }}
                            {{ $t("menuitems.hospital.points") }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </vue-loadmore>
              </div>
            </div>
          </template>
          
          <template #right>
            <div class="col-12 px-3">
              <div class="mt-2 mb-4 d-flex justify-content-between">
                <h5 class="text-list-locomo-7">詳細</h5>
                <div>
                  <button v-if="edit" class="w-lg btn-cancel" @click="cancel">
                    キャンセル
                  </button>
                  <button v-if="(role === 'admin' && !edit) || (role === 'hospital' && !edit && time_out_facility === null)" class="w-lg btn-edit" @click="toEdit">
                    編集
                  </button>
                  <button v-if="['admin','hospital'].includes(role) && edit" class="w-lg btn-edit" @click="editLocomo7">
                    保存
                  </button>
                </div>
              </div>
              <div v-if="!edit" class="row mb-4 scroll" :style="{maxHeight: isExpand ? '60vh': '50vh'}">
                <div class="col-xl-6 col-md-12 mb-2" v-for="(question, index) in questions" :key="index">
                  <div class="row">
                    <div class="col-2 d-flex align-items-center">
                      <input class="form-check-input m-2" type="checkbox"
                        id="formCheckRight2"
                        :checked="isCheckedAnswerLocomo(question.images[0].imageable_id)" style="font-size: 24px" disabled/>
                    </div>
                    <div class="col-10 d-flex-inline">
                      <img :src="question.images[0].url ? question.images[0].url : ''" alt class="m-2 avatar-xl" />
                      <h6 class="text-image-locomo-7 align-items-center">
                        {{ question.images[0].name ? question.images[0].name : "" }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="edit" class="row mb-4 scroll" :style="{maxHeight: isExpand ? '60vh': '50vh'}">
                <div class="col-xl-6 col-md-12 mb-2" v-for="(question, index) in questions" :key="index">
                  <div class="row"  @click="checkedAnswerLocomo(question.images[0].imageable_id)">
                    <div class="col-2 d-flex align-items-center">
                      <input class="form-check-input m-2" type="checkbox"
                        id="formCheckRight2"
                        :checked="isCheckedAnswerLocomo(question.images[0].imageable_id)" style="font-size: 24px" />
                    </div>
                    <div class="col-10 d-flex-inline">
                      <img :src="question.images[0].url ? question.images[0].url : ''" alt class="m-2 avatar-xl" />
                      <h6 class="text-image-locomo-7 align-items-center">
                        {{ question.images[0].name ? question.images[0].name : "" }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Spliter>
      </div>
    </div>
    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import {getProfile} from "../../helpers/Auth";
import api from "@/api";
import moment from 'moment';
import Spliter from "./spliter.vue";

export default {
  filters: {
    ...filter,
  },
  components: {Spliter},
  props: ["locomo7", "pagination", "time_out_facility", "userInfor", "isExpand"],

  data() {
    return {
      images: [],
      questions: [],
      clickIndex: 0,
      enabledExportPDF: false,

      role: getProfile().role.name,
      edit: false,
      dataEdit: [],

      answers: [],

      flagPDFAll: false,
      listIds: [],

      list: [],
      page: 1,
      finished: false,

    };
  },

  async created() {
    if (this.locomo7 && this.locomo7.length > 0) {
      this.images = this.locomo7[0].images;
      // this.pageSize = this.pagination.total;
      this.answers = this.locomo7[0].answer;
      this.dataEdit = {
        uuid: this.locomo7[0].uuid,
        answer: [],
      }
    }

    api.getQuestionsLocomo7(this.role).then((res) => {
        this.questions = JSON.parse(JSON.stringify(res.data.sub_questions)) || [];
    })
  },

  mounted() {
    this.fetchPage();
  },

  computed: {},

  watch: {
    locomo7: {
      handler() {
        if (this.locomo7.length > 0) {
          this.images = this.locomo7[this.clickIndex].images;
          this.answers = this.locomo7[this.clickIndex].answer;
          this.dataEdit = {
            uuid: this.locomo7[this.clickIndex].uuid,
            answer: JSON.parse(JSON.stringify(this.answers)),
          }
        }
      },
    },

    clickIndex(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.cancel();
      }
    },

    answers: {
      handler() {
          this.dataEdit = {...this.dataEdit, answer: JSON.parse(JSON.stringify(this.answers))};
      },
    }
  },

  methods: {
    onRefresh(done) {
      this.list = [];
      this.page = this.page;
      this.finished = false;
      this.fetchPage();

      done();
    },

    onLoad(done) {
      if (this.page <= this.pagination.last_page) {
        this.nextPage();
      } else {
        // all data loaded
        this.finished = true;
      }
      done();
    },

    fetchPage() {
      for (let i = 0; i <= this.pagination.last_page; i++) {
        this.list.push(this.list.length + 1);
      }
      this.page++;
    },

    nextPage() {
      this.$emit("loadMoreLocomo7");
      this.page++;
    },

    checkedLocomo(id) {
      const index = this.listIds.findIndex(function (item) {
        return item.indexOf(id) !== -1;
      });
      if (index >= 0) {
        this.listIds.splice(index, 1);
      } else {
        this.listIds.push(id);
      }
    },

    checkedAnswerLocomo(imageable_id) {
      let answer = this.dataEdit.answer.result.find(item => item.imageable_id === imageable_id);
      if(answer) {
        answer.score = !answer.score ? 1 : 0;
      }
    },

    isCheckedAnswerLocomo(imageable_id){
      if (this.dataEdit.answer.result.find(item => item.imageable_id === imageable_id)?.score == 1) return true;
      return false;
    },

    isChecked(uuid) {
      if (this.listIds.includes(uuid)) return true;
      return false;
    },

    isCheckedAll() {
      if (this.locomo7.length === this.listIds.length) return true;
      return false;
    },

    getImages(index) {
      try {
        this.images = this.locomo7[index].images;
        this.answers = this.locomo7[index].answer;
        this.dataEdit = {
          uuid: this.locomo7[index].uuid,
          answer: JSON.parse(JSON.stringify(this.answers)),
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    selectAll($event) {
      this.flagPDFAll = $event.target.checked;
      if (!this.flagPDFAll) {
        this.listIds = [];
      } else {
        this.listIds = this.locomo7.map((e) => e.uuid);
      }
    },

    exportPDF() {
      if (this.listIds.length > 6) {
        window.toastr.error("最大数量は６件です。");
        return;
      }

      if (this.flagPDFAll && this.listIds.length === this.locomo7.length) {
        this.$emit("pdfLocomos7");
      } else {
        this.$emit("pdfLocomo7", this.listIds);
      }

      this.listIds = [];
      this.flagPDFAll = false;
    },

    exportExcel() {
      const payload = {};
      payload.ids = this.listIds.toString();
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportHistory('locomo7', payload, `７つのロコチェック_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`);
      } catch (error) {
        console.log(error);
      }
    },

    toEdit() {
      this.edit = true;
    },

    async editLocomo7() {
      try {
        if(this.edit){
          const answer = JSON.parse(JSON.stringify(this.dataEdit.answer.result));
          const result = answer.reduce((acc, item) => {
              acc[item.imageable_id] = {
                  score: item.score,
                  id: item.id
              };
              return acc;
          }, {});

          const respon = await api.updateLocomo7(
            this.role,
            this.dataEdit.uuid,
            {
              uuid: this.dataEdit.uuid,
              result: {
                max_score: this.dataEdit.answer.max_score,
                result: result,
              }
            }
          );

          if (respon.status == 200) {
            this.$emit('reloadLocomo7');
            this.edit = !this.edit;
          }
        }
      }catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },

    cancel() {
      this.dataEdit = {...this.dataEdit, answer : JSON.parse(JSON.stringify(this.answers)),};
      this.edit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-list-locomo-7 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

* {
  font-family: "Noto Sans JP";
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #b8e060;
}

.text-end {
  align-items: end;
}

.scroll {
  // max-height: 50vh;
  overflow-y: scroll;
}
.select-all {
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}
.form-check-input {
  cursor: pointer;
}

.text-right {
  text-align: right;
}

.btn-edit {
  color: white;
  background-color: #8fc31f;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}

.btn-cancel {
  color: #ff5858;
  background-color: white;
  border: 1px solid #ff5858;
  border-radius: 4px;
  padding: 5px;
}

.bg-disabled {
  background: #ffffff !important;
  color: #d3d3d3 !important;
}
</style>
